export default () => ({
  page: {
    all: 1,
    outlet: 1,
    influencer: 1,
  },
  pageSize: {
    all: 100,
    outlet: 100,
    influencer: 100,
  },
  totalContacts: 0,
  sortBy: {
    all: "relevance",
    outlet: "relevance",
    influencer: "relevance",
  },
  selectedIds: [],
  sortDirection: {
    all: "asc",
    outlet: "desc",
    influencer: "desc",
  },
  keywordQuery: "",
  keywordOutletFields: [
    "name_analysed",
    "owner",
    "outlet_addresses",
    "email",
    "profile",
  ],
  keywordInfluencerFields: [
    "name_analysed",
    "influencer_business_cards.title",
    "twitter_bio",
    "email",
    "influencer_addresses",
  ],
  ignoreDefaultCountryFilters: false,
  scrollTop: 0,
  searchTab: "all",
  filterLocations: [],
  filterTalkingAboutTags: [],
  filterTalkingAboutOperator: "AND",
  filterTargetAreas: [],
  filterTopics: [],
  filterLanguages: [],
  filterSocials: [],
  filterCoverages: [],
  filterMediaTypes: [],
  filterCirculation: {
    enabled: false,
    gte: null,
    lte: null,
  },
  filterFrequencies: [],
  filterContentTypes: [],
  filterDesignatedMarketAreas: [],
});
